import React, { useEffect } from 'react';

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import routes from './routes';
import Main from './app/ui/Main';
import { getUniqueId, setUniqueId } from './helper/localStorage';

// import 'react-calendar/dist/Calendar.css';

function App() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    if (!getUniqueId) { setUniqueId() }
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      // if (route.collapse) {
      //   return getRoutes(route.collapse);
      // }

      if (route.route) {
        return <Route path={route.route} element={route.component} key={route.key} />;
      }

      return null;
  });

  return (
    <Routes>
      {getRoutes(routes)}
      <Route key={'main'} path="/" element={<Main />} />
      <Route key={'default'} path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
